export const TableHead = ({ children }) => {
  return (
    <thead className="bg-[#EDF1F6] border-b-2 border-gray-200">
      <tr className="[&>th]:p-3 [&>th]:font-semibold [&>th]:tracking-wide [&>th]:text-left text-theme-blue">
        {children}
      </tr>
    </thead>
  );
};
